// Components
import {
  Typography,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CustomButton from "../../constants/CustomButton";
import { CalendarMonth, ExpandMore } from "@mui/icons-material";

// Styles
import { styles } from "../styles";

// Wrapper for bold text within Typography
const BoldSpan = ({ children }) => (
  <Typography
    component="span"
    sx={{ ...styles.typographyBody, fontWeight: "bold" }}
  >
    {children}
  </Typography>
);

const informationText = [
  {
    title: "Follow-Up Patients",
    details:
      "If a provider has requested a follow-up appointment, please call the clinic directly. Follow-up visits must be scheduled with the same provider you originally saw for your concern. Please note that any follow-up appointments booked online may be cancelled at our discretion.",
  },
  {
    title: "Referral Patients",
    details:
      "If a provider has referred you to see us for further care, please call the clinic instead of booking an online appointment. Referral time slots are not available for online booking. If you are a referral patient upon arrival, your appointment will be rescheduled.",
  },
  {
    title: "X-Ray Patients",
    details: (
      <>
        {
          "If you have a requisition from another clinic for an X-ray, do not book an appointment with us. X-ray on Corydon operates as a separate walk-in clinic. Any appointments booked for X-rays where you already have a requisition at check-in will be cancelled and will be subject to the "
        }
        <BoldSpan>$75 late-cancellation fee</BoldSpan>
        {"."}
      </>
    ),
  },
];

const ImportantInformation = ({ onBook }) => {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{ py: 2, mx: "auto", width: { xs: "90%", md: "80%" } }}
    >
      <Typography sx={styles.typographyTitle}>IMPORTANT INFORMATION</Typography>
      <Stack spacing={0}>
        {informationText.map((item) => (
          <Accordion
            key={item.title}
            defaultExpanded
            sx={{
              "&.Mui-expanded": { margin: 0 },
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography component="span" sx={styles.typographyAccordionTitle}>
                {item.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={styles.typographyAccordion}>
              {item.details}
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
      <CustomButton
        onClick={onBook}
        label="Make an Appointment"
        startIcon={<CalendarMonth />}
        sx={{ fontWeight: "bold" }}
      />
    </Stack>
  );
};

export default ImportantInformation;
